export default "__VITE_ASSET__Dh05GhJZ__"